import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.settings');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";


@Component({
    selector: 'wiz-page-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.settings/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.settings-navigation {
  box-shadow: var(--wb-shadow-xs);
}

.settings-tab {
  display: flex;
  min-width: 0;
  min-height: 4rem;
  align-items: center;
  gap: 0.65rem;
  border: 1px solid transparent;
  border-radius: 0.7rem;
  padding: 0.65rem;
  background: transparent;
  color: var(--wb-ink-soft);
  text-align: left;
}

.settings-tab:hover {
  background: var(--wb-surface-muted);
  color: var(--wb-ink);
}

.settings-tab-active,
.settings-tab-active:hover {
  border-color: var(--wb-brand-border);
  background: var(--wb-brand-soft);
  color: var(--wb-brand-hover);
}

.settings-tab-icon {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.6rem;
  background: var(--wb-surface-strong);
  color: var(--wb-muted);
  font-size: 0.8rem;
}

.settings-tab-active .settings-tab-icon {
  background: var(--wb-brand);
  color: white;
}

.settings-tab strong {
  font-size: 0.8125rem;
  line-height: 1.25;
}

.settings-tab small {
  margin-top: 0.2rem;
  color: var(--wb-subtle);
  font-size: 0.75rem;
  line-height: 1.25;
}

.settings-tab-badge {
  min-width: 1.55rem;
  height: 1.55rem;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 0 0.4rem;
  background: var(--wb-surface-strong);
  color: var(--wb-muted);
  font-size: 0.75rem;
  font-weight: 700;
}

.settings-tab-active .settings-tab-badge {
  background: white;
  color: var(--wb-brand);
}

.settings-execution-card {
  color: #8a4b08;
}

.settings-execution-card.execution-enabled {
  border-color: #ecd39e;
  background: #fff7e6;
}

.settings-execution-card.execution-disabled {
  border-color: #f2b8b3;
  background: #fff1f0;
  color: #b42318;
}

.settings-execution-icon {
  background: rgba(255, 255, 255, 0.72);
  color: currentColor;
}

@media (max-width: 1023px) {
  .settings-tab {
    min-height: 3.5rem;
    justify-content: center;
    padding: 0.55rem;
    text-align: center;
  }
  .settings-tab-icon {
    display: none;
  }
}
@media (max-width: 639px) {
  .settings-tab {
    min-height: 3rem;
    padding: 0.5rem 0.35rem;
  }
  .settings-tab strong {
    font-size: 0.75rem;
  }
}`],
})
export class PageSettingsComponent implements OnInit {
    public loading: boolean = true;
    public mutating: boolean = false;
    public errorMessage: string = '';
    public activeTab: string = 'patients';
    public patients: any = { rows: [], total: 0, page: 1, has_next: false };
    public erasures: any = { rows: [], total: 0, page: 1, has_next: false, execution_enabled: false };
    public filters: any = { text: '', legal_hold: '', eligibility: '', request_status: '' };
    public selectedPatient: any = null;
    public patientModal: string = '';
    public policyForm: any = { retention_until: '', legal_hold: false, reason_code: '' };
    public previewData: any = null;
    public erasureReason: string = 'retention_expired';
    private mutationKeys: any = {};
    private patientModalReturnFocus: HTMLElement | null = null;

    public legalHoldReasons: any[] = [
        { value: 'court_order', label: '법원 명령' },
        { value: 'regulatory_investigation', label: '규제 조사' },
        { value: 'clinical_safety_review', label: '임상 안전 검토' },
        { value: 'security_incident', label: '보안 사고' },
        { value: 'other', label: '기타' }
    ];
    public erasureReasons: any[] = [
        { value: 'retention_expired', label: '보존 기한 만료' },
        { value: 'patient_request', label: '환자 요청' },
        { value: 'regulatory_request', label: '규제기관 요청' },
        { value: 'data_correction', label: '데이터 정정' },
        { value: 'other', label: '기타' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        if (this.service.auth?.session?.role !== 'admin') {
            location.href = '/dashboard';
            return;
        }
        await this.load();
    }

    public async load(reset: string = '') {
        if (reset === 'patients') this.patients.page = 1;
        if (reset === 'erasures') this.erasures.page = 1;
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('bootstrap', {
                ...this.filters,
                patient_page: this.patients.page || 1,
                request_page: this.erasures.page || 1
            });
            if (code !== 200) {
                this.errorMessage = data?.message || '운영 설정을 불러오지 못했습니다.';
                return;
            }
            this.patients = data?.patients || { rows: [], total: 0, page: 1, has_next: false };
            this.erasures = data?.erasures || { rows: [], total: 0, page: 1, has_next: false, execution_enabled: false };
        } catch (error) {
            this.errorMessage = '운영 설정을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async selectTab(tab: string) {
        this.activeTab = tab;
        await this.service.render();
    }

    public async movePatients(delta: number) {
        const next = Number(this.patients.page || 1) + delta;
        if (next < 1 || (delta > 0 && !this.patients.has_next)) return;
        this.patients.page = next;
        await this.load();
    }

    public async moveErasures(delta: number) {
        const next = Number(this.erasures.page || 1) + delta;
        if (next < 1 || (delta > 0 && !this.erasures.has_next)) return;
        this.erasures.page = next;
        await this.load();
    }

    public async openPolicy(patient: any) {
        this.patientModalReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.selectedPatient = patient;
        this.patientModal = 'policy';
        this.previewData = null;
        this.policyForm = {
            retention_until: String(patient.retention_until || '').slice(0, 10),
            legal_hold: patient.legal_hold === true,
            reason_code: patient.legal_hold_reason_code || ''
        };
        await this.service.render();
        setTimeout(() => document.getElementById('policy-retention-until')?.focus(), 0);
    }

    public async closePatientModal() {
        this.selectedPatient = null;
        this.patientModal = '';
        this.previewData = null;
        await this.service.render();
        const target = this.patientModalReturnFocus;
        this.patientModalReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onPatientModalKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape' && !this.mutating) {
            event.preventDefault();
            void this.closePatientModal();
            return;
        }
        if (event.key !== 'Tab') return;

        const dialog = document.getElementById(`settings-${this.patientModal}-dialog`);
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public legalHoldChanged() {
        if (!this.policyForm.legal_hold) this.policyForm.reason_code = '';
    }

    public async savePolicy() {
        if (!this.selectedPatient || this.mutating) return;
        if (this.policyForm.legal_hold && !this.policyForm.reason_code) {
            await this.service.modal.error('법적 보존 사유를 선택해주세요.');
            return;
        }
        const confirmed = await this.service.modal.show({
            title: '보존 정책 변경',
            message: `${this.selectedPatient.patient_code}의 보존 기한과 법적 보존 상태를 변경합니다.`,
            action: '변경',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;
        this.mutating = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('policy', {
                patient_id: this.selectedPatient.patient_id,
                retention_until: this.policyForm.retention_until,
                legal_hold: this.policyForm.legal_hold,
                reason_code: this.policyForm.reason_code,
                expected_version: this.selectedPatient.version,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code === 200) {
                await this.closePatientModal();
                await this.load();
            } else {
                await this.service.modal.error(data?.message || '보존 정책을 변경하지 못했습니다.');
                await this.load();
            }
        } catch (error) {
            await this.service.modal.error('보존 정책을 변경하지 못했습니다.');
        } finally {
            this.mutating = false;
            await this.service.render();
        }
    }

    public async preview(patient: any) {
        this.patientModalReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.selectedPatient = patient;
        this.patientModal = 'preview';
        this.previewData = null;
        this.erasureReason = 'retention_expired';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('preview', { patient_id: patient.patient_id });
            if (code === 200) this.previewData = data.preview;
            else {
                await this.closePatientModal();
                await this.service.modal.error(data?.message || '삭제 사전 점검을 완료하지 못했습니다.');
            }
        } catch (error) {
            await this.closePatientModal();
            await this.service.modal.error('삭제 사전 점검을 완료하지 못했습니다.');
        } finally {
            await this.service.render();
            if (this.patientModal === 'preview' && this.previewData) {
                setTimeout(() => document.getElementById('settings-preview-close')?.focus(), 0);
            }
        }
    }

    public async requestErasure() {
        if (!this.selectedPatient || !this.previewData?.eligible || this.mutating) return;
        const confirmed = await this.service.modal.show({
            title: '삭제 요청 생성',
            message: '실제 삭제가 아닙니다. 다른 관리자의 승인을 받아야 하며 승인 전까지 실행되지 않습니다.',
            action: '요청 생성',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;
        const scope = `request:${this.selectedPatient.patient_id}`;
        let idempotencyKey = '';
        try {
            idempotencyKey = this.keyFor(scope);
        } catch (error) {
            await this.service.modal.error('안전한 요청 식별자를 만들 수 없어 삭제 요청을 중단했습니다.');
            return;
        }
        this.mutating = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('request', {
                patient_id: this.selectedPatient.patient_id,
                reason_code: this.erasureReason,
                idempotency_key: idempotencyKey,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code === 201) {
                this.clearKey(scope);
                await this.closePatientModal();
                this.activeTab = 'erasures';
                await this.load();
            } else {
                await this.service.modal.error(data?.message || '삭제 요청을 생성하지 못했습니다.');
            }
        } catch (error) {
            await this.service.modal.error('삭제 요청을 생성하지 못했습니다. 같은 요청 식별자로 다시 시도할 수 있습니다.');
        } finally {
            this.mutating = false;
            await this.service.render();
        }
    }

    public canApprove(item: any) {
        return item?.status === 'requested'
            && item?.requested_by !== this.service.auth?.session?.id;
    }

    public async approve(item: any) {
        if (!this.canApprove(item) || this.mutating) return;
        const confirmed = await this.service.modal.show({
            title: '2차 관리자 승인',
            message: '요청자와 다른 관리자로서 삭제 범위와 차단 조건을 검토했음을 확인합니다.',
            action: '승인',
            actionBtn: 'warning',
            status: 'warning'
        });
        if (!confirmed) return;
        const scope = `approve:${item.id}`;
        await this.erasureMutation('approve', item, scope, '삭제 요청을 승인하지 못했습니다.');
    }

    public canExecute(item: any) {
        return item?.status === 'approved'
            && item?.execution_enabled === true
            && this.erasures?.execution_enabled === true;
    }

    public async execute(item: any) {
        if (!this.canExecute(item) || this.mutating) return;
        const confirmed = await this.service.modal.show({
            title: '비가역 삭제 실행',
            message: '이 작업은 승인된 요청을 다시 검증한 뒤 복구할 수 없는 삭제를 수행합니다. 서버 실행 플래그와 모든 차단 조건이 통과해야 합니다.',
            action: '삭제 실행',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;
        const scope = `execute:${item.id}`;
        await this.erasureMutation('execute', item, scope, '삭제 실행이 차단되었습니다.');
    }

    private async erasureMutation(action: string, item: any, scope: string, fallback: string) {
        let idempotencyKey = '';
        try {
            idempotencyKey = this.keyFor(scope);
        } catch (error) {
            await this.service.modal.error('안전한 요청 식별자를 만들 수 없어 작업을 중단했습니다.');
            return;
        }
        this.mutating = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call(action, {
                request_id: item.id,
                expected_version: item.version,
                idempotency_key: idempotencyKey,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code === 200) {
                this.clearKey(scope);
                await this.load();
            } else {
                await this.service.modal.error(data?.message || fallback);
                await this.load();
            }
        } catch (error) {
            await this.service.modal.error(`${fallback} 같은 요청 식별자로 다시 시도할 수 있습니다.`);
        } finally {
            this.mutating = false;
            await this.service.render();
        }
    }

    private keyFor(scope: string) {
        if (!this.mutationKeys[scope]) {
            const browserCrypto: any = (window as any).crypto;
            if (!browserCrypto || typeof browserCrypto.getRandomValues !== 'function') {
                throw new Error('secure random unavailable');
            }
            const values = new Uint32Array(4);
            browserCrypto.getRandomValues(values);
            const random = Array.from(values)
                .map((value: number) => value.toString(16).padStart(8, '0'))
                .join('');
            this.mutationKeys[scope] = `ui:${random}`;
        }
        return this.mutationKeys[scope];
    }

    private clearKey(scope: string) {
        delete this.mutationKeys[scope];
    }

    public blockerLabel(value: string) {
        const labels: any = {
            patient_not_archived: '환자 상태가 보관 완료가 아님',
            retention_unset: '보존 기한 미설정',
            retention_not_reached: '보존 기한 미도래',
            legal_hold: '법적 보존 중',
            active_generation_jobs: '진행 중인 생성 작업 존재',
            active_therapy_sessions: '진행 중인 치료 세션 존재'
        };
        return labels[value] || value;
    }

    public requestStatusLabel(value: string) {
        const labels: any = {
            requested: '승인 대기', approved: '승인됨', executed: '실행 완료'
        };
        return labels[value] || value || '-';
    }

    public reasonLabel(value: string) {
        const all = [...this.legalHoldReasons, ...this.erasureReasons];
        const found = all.find(item => item.value === value);
        return found?.label || value || '-';
    }

    public date(value: any) {
        return String(value || '').replace('T', ' ').slice(0, 19) || '-';
    }

    public countEntries(value: any) {
        return value && typeof value === 'object' ? Object.entries(value) : [];
    }
}

export default PageSettingsComponent;